// extracted by mini-css-extract-plugin
export default {"form":"Form_form__rYsP9","input":"Form_input__8miLl","footer":"Form_footer__kw11W","clearPass":"Form_clearPass__bm6TS"};